import { urlReplace } from "helpers/url";
import Api from "./Api";

export default class TaskService {
	constructor(api) {
		this.api = api || new Api();
	}

	async getAll(params) {
		return this.api.get('/secure/tasks', params);
	}

	async getAllMe(params) {
		return this.api.get('/secure/tasks/me', params);
	}

	async getById(id, params) {
		return this.api.get(urlReplace('/secure/task/{id}', { id: id }), params);
	}
}

